module.exports = require("clipboardy");